import { render, staticRenderFns } from "./ClientClouds.vue?vue&type=template&id=7897452f&"
import script from "./ClientClouds.vue?vue&type=script&lang=js&"
export * from "./ClientClouds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports